import JSZip from "jszip";
import API from "api/API";
import { prepareUDTable } from "utils/prepareDataHelpers";
import { buildPreparedTablesCsvString } from "utils/buildPreparedTablesCsvString";
import { findKeyVariableInTopics } from "module/UDModule/utils/findKeyVariableInTopics";
import { findEdition2VariableId } from "module/UDModule/utils/findEdition2VariableId";

function resolveUdVariableName(variableId, displayTopics, isCompareMode) {
   const item = findKeyVariableInTopics(variableId, displayTopics, isCompareMode);
   return item?.name || `wskaznik_${variableId}`;
}

function sanitizeFilename(name) {
   const s = String(name).replace(/[/\\?%*:|"<>]/g, "_").trim();
   return s || "wskaznik";
}

function groupingVariableIdFromParams(grouping_variable_ids) {
   if (!grouping_variable_ids?.length) return null;
   return grouping_variable_ids[0];
}

/**
 * Pobiera dane wykresów dla każdego wskaźnika z listy i pakuje osobne CSV do jednego ZIP.
 */
export async function downloadUdMultiIndicatorZip({
   key_variable_ids,
   isCompareMode,
   edition1Id,
   edition2Id,
   editionLabel,
   edition2Label,
   grouping_variable_ids,
   filters,
   displayTopics,
   topicsEdition1,
   topicsEdition2
}) {
   if (!key_variable_ids?.length || !edition1Id) {
      throw new Error("Brak danych do eksportu");
   }

   const zip = new JSZip();

   for (const vid of key_variable_ids) {
      const varName = resolveUdVariableName(vid, displayTopics, isCompareMode);
      const baseFileName = `${sanitizeFilename(varName)}_${vid}`;

      let raw;
      if (isCompareMode) {
         if (!edition2Id) throw new Error("Brak drugiej edycji");
         const key2 =
            findEdition2VariableId(vid, displayTopics, topicsEdition1, topicsEdition2) ?? vid;
         raw = await API.getCompareCharts({
            edition1_id: edition1Id,
            edition2_id: edition2Id,
            key_variable_id_edition1: vid,
            key_variable_id_edition2: key2,
            grouping_variable_id: groupingVariableIdFromParams(grouping_variable_ids),
            filters
         });
      } else {
         raw = await API.getCharts({
            edition_id: edition1Id,
            key_variable_id: vid,
            grouping_variable_ids,
            filters
         });
      }

      const chartData = Array.isArray(raw) ? raw : raw?.charts || raw;
      if (!Array.isArray(chartData) || chartData.length === 0) {
         zip.file(
            `${baseFileName}.csv`,
            "\uFEFFBrak danych dla tego wskaźnika przy bieżących filtrach.\n"
         );
         continue;
      }

      const tables = chartData.map((item) =>
         isCompareMode
            ? prepareUDTable(item, varName, null, true, editionLabel, edition2Label)
            : prepareUDTable(item, varName, null)
      );
      const csv = buildPreparedTablesCsvString(tables, "UD");
      zip.file(`${baseFileName}.csv`, csv);
   }

   const blob = await zip.generateAsync({ type: "blob" });
   const url = URL.createObjectURL(blob);
   const a = document.createElement("a");
   a.href = url;
   a.download = "tabele_ud_zskstat.zip";
   a.click();
   URL.revokeObjectURL(url);
}
